var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/tiles.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/tiles.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += "\r\n\r\n<div class=\"grid big-ui\">\r\n\t<div class=\"table-form\" style=\"padding: 15px 19px 0\">\r\n\t\t<div class=\"col col-xs-12\">\r\n\t\t\t";
output += runtime.suppressValue((lineno = 5, colno = 27, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"scan")])), env.opts.autoescape);
output += "\r\n\t\t</div>\r\n\r\n\t\t";
output += "\r\n\r\n\t\t<br style=\"clear:both\">\r\n\t</div>\r\n\r\n\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data") == runtime.contextOrFrameLookup(context, frame, "null") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"Tiles") == runtime.contextOrFrameLookup(context, frame, "null") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"Tiles")),"length") < 1) {
output += "\r\n\t\t<br><br>\r\n\t\t<p style=\"text-align: center\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"NoRowsFound"), env.opts.autoescape);
output += "</p>\r\n\t";
;
}
else {
output += "\r\n\t";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"Tiles");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("tile", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n\t";
if(runtime.memberLookup((t_7),"IsNewSection")) {
output += "<div style=\"clear:both\"><hr></div>";
;
}
output += "\r\n\t<div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-2\">\r\n\t\t<div style=\"margin: 15px; padding: 12px; border: 1px solid #cccccc\" ";
if(runtime.memberLookup((t_7),"Event")) {
output += " ";
output += " ";
;
}
output += ">\r\n\t\t\t<strong style=\"display: block; text-align: center\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"Title"), env.opts.autoescape);
output += "</strong>\r\n\r\n\t\t\t<img src=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_7),"ImageUrl")), env.opts.autoescape);
output += "\" onerror=\"this.src='http://placehold.it/350x350';\" style=\"width: 100%; height: auto\">\r\n\r\n\t\t\t";
if(runtime.memberLookup((t_7),"Text")) {
output += "<p style=\"text-align: center; height: 50px;\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"Text") || "-", env.opts.autoescape);
output += "</p>";
;
}
output += "\r\n\t\t\t";
if(runtime.memberLookup((t_7),"DateDescription")) {
output += "<p style=\"text-align: center; height: 50px;\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"DateDescription") || "-", env.opts.autoescape);
output += "</p>";
;
}
output += "\r\n\r\n\t\t\t<div style=\"text-align: center\">\r\n\t\t\t\t<button class=\"button button-menu counter decrement\">-</button>\r\n\t\t\t\t<button class=\"button button-menu fake-button no-hover no-action counter display\">";
output += runtime.suppressValue(runtime.memberLookup((t_7),"DefaultAmount"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t<button class=\"button button-menu counter increment\">+</button>\r\n\t\t\t\t<input type=\"hidden\" name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"Id"), env.opts.autoescape);
output += "\" min=\"0\" max=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"MaxAmount"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"DefaultAmount"), env.opts.autoescape);
output += "\" class=\"counter value\">\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t";
;
}
}
frame = frame.pop();
output += "\r\n\t";
;
}
output += "\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/tiles.html"] , dependencies)